import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-multi-select-of-days',
  templateUrl: './multi-select-of-days.component.html',
})
export class MultiSelectOfDaysComponent implements OnInit {
@Input() placeholder: string= "Días"
@Input() isMultiple: boolean = true;
days: FormControl = new FormControl();
@Output() onDayChange = new EventEmitter<any>();
  
listOfDays: any[] = [
  {value:"LUN", text:"Lunes"},
  {value:"MAR", text:"Martes"},
  {value:"MIE", text:"Miercoles"},
  {value:"JUE", text:"Jueves"},
  {value:"VIE", text:"Viernes"},
  {value:"SAB", text:"Sábado"},
  {value:"DOM", text:"Domingo"}
];
  constructor() { }

  ngOnInit() {
  }

  setDays(daysSelected:any){
    this.days.setValue(daysSelected);
    this.changeDaySelection();
  }
  changeDaySelection(){
   this.onDayChange.emit(this.days.value);
  }

}
